import Repository from '../Repository';

const resource = '/configuration';

export default {
	index() {
		return Repository.get(`${resource}`);
	}
}